import React, { useEffect, useMemo, useState } from 'react';
import FullWidthModal from '../../components/common/Modal/FullWidthModal';
import ModalHeader from '../../components/common/ModalHeader/index';
import cn from 'classnames';
import styles from './viewreceipt.module.scss';
import { TouchableButton } from '../../components/common/Touchable/index';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import Loader from '../../components/common/Loader/newLoaderModal';
import { ReactComponent as LoyaltyCheck } from '@assets/images/loyaltyCheck.svg';
import { connect } from 'react-redux';
import { FormatLoyaltyPhoneNumber } from '@utility/helperFunction';
import ModalPopup from '../../components/common/Modal';

const SplitRewardsList = props => {
  const {
    newRewardPopUp,
    serverAppTheme,
    seat,
    handleRedeemReward,
    handleSplitRewardDone,
    handleSplitRewardCancel,
    onNavigateToRedemption,
    allowPartialRewardRedemption,
    redeemRewardsSeparately,
    redeemedRewardIds,
    loading,
    orderingPortraitOrientation,
  } = props;

  const [selectedLyltChecks, setSelectedLyltChecks] = useState([]);
  const seatData = JSON.parse(window.sessionStorage.getItem('seat'));
  const [applyRewardConfirm, setApplyRewardConfirm] = useState(null);

  const popUpModal = useMemo(() => {
    const okButton = {
      backgroundColor: serverAppTheme?.secondaryBtn,
      color: '#ffff',
      border: 'none',
      borderRadius: '8px',
    };
    return { okButton };
  }, [serverAppTheme]);

  const handleSeatNumber = (data) => {
    let seats = [];
    if (seatData?.paymentCheck?.splitType === 0) {
      seats = seatData?.paymentCheck?.seats || [];
    } else {
      const selectedLoyalty = seat?.paymentChecks?.find(e => Number(e?.checkSplitId) === Number(data));
      seats = selectedLoyalty?.seats || [];
    }
    const sortedSeats = seats?.sort((a, b) => {
      const numA = (a.number !== null && a?.number !== undefined) ? Number(a?.number) : Infinity;
      const numB = (b.number !== null && b?.number !== undefined) ? Number(b?.number) : Infinity;
      return numA - numB;
    });
    return sortedSeats.map(e => e?.number?.toString() ?? '').filter(Boolean).join(',');
  };

  const getSeatNumber = (checkId, seatId) => {
    if (seatData?.paymentCheck?.splitType === 0) {
      return seat?.paymentCheck?.seats?.find(e => e?.id === seatId)?.number;
    }
    const selectedSeat = seat?.paymentChecks?.find(e => Number(e.checkSplitId) === Number(checkId));
    return selectedSeat?.seats?.find(e => e?.id === seatId)?.number;
  };

  const getLoyaltyNameAccount = (checkId, lytId) => {
    const findSeat = seat?.paymentChecks?.find(e => Number(e.checkSplitId) === Number(checkId));
    return findSeat?.loyalties?.find(e => e?.id === lytId);
  };

  const handleDisplayCheckNumber = (data) => {
    if (seatData?.paymentCheck?.splitType === 0) {
      return seatData?.paymentCheck?.splitNumber;
    }
    const selectedSplit = seat?.paymentChecks?.find(e => Number(e.checkSplitId) === Number(data));
    return selectedSplit?.splitNumber;
  };

  // Filter availableLoyaltyOffers accounts to only include offerCategory === 1 rewards
  // and sort the rewards per seat number
  const filteredAvailableRewards = useMemo(() => {
    if (!seat?.availableLoyaltyOffers) return {};
    const result = {};
    Object.entries(seat.availableLoyaltyOffers).forEach(([accountId, accounts]) => {
      if (!Array.isArray(accounts)) return;
      const filteredAccounts = accounts
        .map(account => ({
          ...account,
          offers: (account.offers || []).filter(offer => offer.offerCategory === 1),
        }))
        .filter(account => account.offers.length > 0);
      if (filteredAccounts.length > 0) {
        filteredAccounts.sort((a, b) => {
          let seatA_num, seatB_num;
          if (seatData?.paymentCheck?.splitType === 0) {
            seatA_num = seat?.paymentCheck?.seats?.find(e => e?.id === a.seatId)?.number;
            seatB_num = seat?.paymentCheck?.seats?.find(e => e?.id === b.seatId)?.number;
          } else {
            const checkSelected = seat?.paymentChecks?.find(e => Number(e?.checkSplitId) === Number(accountId));
            seatA_num = checkSelected?.seats?.find(e => e?.id === a?.seatId)?.number;
            seatB_num = checkSelected?.seats?.find(e => e?.id === b?.seatId)?.number;
          }
          const numA = (seatA_num !== null && seatA_num !== undefined) ? Number(seatA_num) : Infinity;
          const numB = (seatB_num !== null && seatB_num !== undefined) ? Number(seatB_num) : Infinity;
          return numA - numB;
        });
        result[accountId] = filteredAccounts;
      }
    });
    return result;
  }, [seat?.availableLoyaltyOffers]);

  useEffect(() => {
    if (seat?.availableLoyaltyOffers && seat?.paymentChecks) {
      const hashKeys = Object.keys(filteredAvailableRewards);
      const filteredLyltChecks = seat.paymentChecks.filter(item => !hashKeys.includes(item.checkSplitId));
      const checksWithRewards = filteredLyltChecks.filter(check =>
        check.offers?.some(offer => offer.offerCategory === 1)
      );
      setSelectedLyltChecks(checksWithRewards);
    } else {
      setSelectedLyltChecks([]);
    }
  }, [seat?.availableLoyaltyOffers, seat?.paymentChecks, filteredAvailableRewards]);

  const splitRewardSubmit = (reward, accountItem, accountId) => {
    let getSplitId;
    if (seat?.splitType === 0) {
      getSplitId = seat?.paymentCheck;
    } else {
      getSplitId = seat?.paymentChecks?.find(e => Number(e.checkSplitId) === Number(accountId));
    }
    const splitId = getSplitId?.checkSplitId;

    if (allowPartialRewardRedemption) {
      onNavigateToRedemption(reward, accountItem, splitId);
    } else {
      setApplyRewardConfirm({ reward, accountItem, accountId });
      // handleRedeemReward(reward, accountItem, splitId);
    }
  };
  const handleConfirmApplyReward = () => {
    let getSplitId;
    if (seat?.splitType === 0) {
      getSplitId = seat?.paymentCheck;
    } else {
      getSplitId = seat?.paymentChecks?.find(e => Number(e.checkSplitId) === Number(accountId));
    }
    const splitId = getSplitId?.checkSplitId;
    const { reward, accountItem, accountId } = applyRewardConfirm;
     handleRedeemReward(reward, accountItem, splitId);
    setApplyRewardConfirm(null);
  };

  const handleCancelApplyReward = () => {
    setApplyRewardConfirm(null);
  };  

  const matchedOfferValue = (reward, accountItem) => {
    const matchedOffer = seatData?.check?.offers?.find(
      e =>
        e.offerCode === reward?.offerCode &&
        e.checkLoyaltyId === accountItem.checkLoyaltyId &&
        e.seatId === accountItem.seatId
    );
    const amount = matchedOffer?.amount ?? reward?.value ?? 0;
    return Number(amount).toFixed(2)
  }

  return (
    <FullWidthModal
      isOpen={newRewardPopUp}
      customClass2={cn('w-100 h-100 position-relative')}
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        pointerEvents: 'auto',
        backgroundColor: serverAppTheme?.popUp_bg,
        backgroundClip: 'padding-box',
        border: '0',
        boxShadow: serverAppTheme?.popUp_box_shadow,
      }}
    >
      {loading && <Loader />}
      <div
        className="col-12 px-0 justify-content-center align-items-center position-relative text-center h-100"
        style={popUpModal.primaryTextColor}
      >
        <div
          className={cn(
            'col-12 px-0 fs_18 align-items-center justify-content-center fw-600 h-100'
          )}
        >
          <ModalHeader
            stationName={seat?.stationName}
            tileHeader={LABEL().LS_AVAILABLE_REWARDS}
            seatNumber={seat?.number}
          />
          <div
            className={cn(
              'px-2 pt-2 d-flex text-left align-items-center fw-normal mx-2',
              orderingPortraitOrientation ? 'fs_12' : 'fs_14'
            )}
            style={{ color: serverAppTheme?.secondary_text }}
          >
            <div
              className={cn(
                'col-3 mx-0',
                orderingPortraitOrientation ? 'pl-2 pr-0' : 'px-0'
              )}
            >
              Reward
            </div>
            <div className="col-1 px-0 mx-0">Value</div>
            <div
              className={cn(
                'col-1 mx-0',
                orderingPortraitOrientation ? 'pl-2 pr-0' : 'px-0'
              )}
            >
              Seat
            </div>
            <div
              className={cn(
                'col-3 mx-0',
                orderingPortraitOrientation ? 'pl-2 pr-0' : 'px-0'
              )}
            >
              Guest Name
            </div>
            <div className="col-2 px-0 mx-0">Account Number</div>
            <div className="col-2 px-0 mx-0"></div>
          </div>
          <div
            className={cn(
              'overflowY',
              orderingPortraitOrientation ? 'h-80 pt-2' : 'h-75'
            )}
          >
            {Object.entries(filteredAvailableRewards).map(
              ([accountId, accounts]) => (
                <div
                  key={accountId}
                  className={cn(
                    orderingPortraitOrientation ? 'px-3' : 'px-2',
                    (seatData?.paymentCheck
                    ? seatData?.paymentCheck?.splitType === 0
                    : seatData?.paymentChecks?.[0]?.splitType === 3)
                      ? 'pt-2'
                      : 'pt-0'
                  )}
                >
                  <div className="col-12 px-0 py-2">
                    <div
                      className={cn(
                        'col-12 fs_12 fs-12 fw-400 d-flex justify-content-between rounded align-items-center py-2'
                      )}
                      style={{ background: serverAppTheme?.checkDetail_tabs }}
                    >
                      <div className="col-6 text-left p-0">
                        Check {handleDisplayCheckNumber(accountId)}
                      </div>
                      <div
                        className={cn(
                          'col-6 text-right pr-0',
                          styles.scrollableText
                        )}
                      >
                        Seat {handleSeatNumber(accountId)}
                      </div>
                    </div>
                  </div>
                  {Array.isArray(accounts) && accounts.length > 0 ? (
                    accounts.map(accountItem =>
                      accountItem.offers && accountItem.offers.length > 0 ? (
                        accountItem.offers.map(reward => (
                          <div
                            key={reward.id}
                            className={cn(
                              styles.offerTile,
                              'p-2 d-flex text-left align-items-center fw-normal mb-2 rounded',
                              orderingPortraitOrientation ? 'fs_12' : 'fs-16'
                            )}
                            style={{
                              background: serverAppTheme?.checkDetail_tabs,
                              border: serverAppTheme?.select_border,
                            }}
                          >
                            <div className="col-3 px-0 mx-0">{reward.name}</div>
                            <div className="col-1 px-0 mx-0">
                              {LABEL().CURRENCY_SYMBOL}
                              {matchedOfferValue(reward, accountItem)}
                            </div>
                            <div
                              className={cn(
                                'col-1 px-0 mx-0',
                                orderingPortraitOrientation
                                  ? 'd-flex justify-content-center'
                                  : ''
                              )}
                            >
                              <div
                                className="fw-500 color-black roundedSm d-flex justify-content-center align-items-center"
                                style={{
                                  width: '1.8rem',
                                  height: '1.25rem',
                                  background: serverAppTheme?.seat_bg,
                                  color: serverAppTheme?.seat_box_text,
                                }}
                              >
                                {getSeatNumber(accountId, accountItem.seatId)}
                              </div>
                            </div>
                            <div className="col-3 px-0 mx-0">
                              {accountItem?.guestName}
                            </div>
                            <div className="col-2 px-0 mx-0">
                              {FormatLoyaltyPhoneNumber(
                                accountItem?.displayAccountNumber
                              )}
                            </div>
                            <div className="col-2 px-0 mx-0 d-flex justify-content-center">
                              {seatData?.check?.offers?.some(
                                e =>
                                  e.offerCode === reward?.offerCode &&
                                  e.checkLoyaltyId ===
                                    accountItem.checkLoyaltyId &&
                                  e.seatId === accountItem.seatId
                              ) ? (
                                <LoyaltyCheck />
                              ) : (
                                <TouchableButton
                                  type="button"
                                  className={cn(
                                    styles.loyalty_btn,
                                    'col-12 px-0 btn btn-ripple od-primary-btn-bg-color od-primary-btn-font-color',
                                    orderingPortraitOrientation
                                      ? styles.applyBtnFont
                                      : ''
                                  )}
                                  onClick={event => {
                                    event.preventDefault();
                                    splitRewardSubmit(
                                      reward,
                                      accountItem,
                                      accountId
                                    );
                                  }}
                                  style={{
                                    height: orderingPortraitOrientation
                                      ? '24px'
                                      : '7.5vh',
                                  }}
                                  rippleEffect={true}
                                >
                                  {LABEL().LS_REDEEM}
                                </TouchableButton>
                              )}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div key={accountItem?.checkLoyaltyId}>
                          No Rewards in this account
                        </div>
                      )
                    )
                  ) : (
                    <div>No Rewards</div>
                  )}
                </div>
              )
            )}
          </div>

          <div
            className={cn(
              'h-20 color-white pt-12 d-flex justify-content-center',
              orderingPortraitOrientation ? 'col-12 px-3' : ''
            )}
          >
            <div
              className={cn(
                'pl-0 pr-0 d-flex mb-1 mr-2',
                orderingPortraitOrientation ? 'col-6' : 'col-4'
              )}
            >
              <TouchableButton
                type="button"
                className={cn(
                  'col-12 px-0 d-flex justify-content-center align-items-center od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color',
                  styles.loyalty_btn
                )}
                onClick={event => {
                  event.preventDefault();
                  handleSplitRewardCancel();
                }}
                style={{
                  height: '7.5vh',
                  backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                  color: serverAppTheme?.primary_text,
                  border: '1px solid #2541A4',
                }}
                rippleEffect={true}
              >
                <div
                  className={cn(
                    'fw-600',
                    orderingPortraitOrientation ? 'fs_28' : 'fs_24'
                  )}
                >
                  {LABEL().LS_BACK_TO_CHECK}
                </div>
              </TouchableButton>
            </div>
            <div
              className={cn(
                'pl-0 pr-0 d-flex mb-1 justify-content-start',
                orderingPortraitOrientation ? 'col-6' : 'col-4'
              )}
            >
              <TouchableButton
                type="button"
                className={cn(
                  'col-12 px-0 btn-ripple d-flex justify-content-center align-items-center od-primary-btn-bg-color od-primary-btn-font-color',
                  styles.loyalty_btn
                )}
                style={{ height: '7.5vh' }}
                onClick={event => {
                  event.preventDefault();
                  handleSplitRewardDone(seatData?.paymentCheck?.splitType);
                }}
                rippleEffect={true}
              >
                <div
                  className={cn(
                    'fw-600',
                    orderingPortraitOrientation ? 'fs_28' : 'fs_24'
                  )}
                >
                  {LABEL().LS_DONE}
                </div>
              </TouchableButton>
            </div>
          </div>
        </div>
      </div>
      {applyRewardConfirm && (
              <ModalPopup
                isOpen={!!applyRewardConfirm}
                isModalCenter
                style={{
                  backgroundColor: serverAppTheme?.popUp_bg,
                  borderRadius: '16px',
                  border: serverAppTheme?.popupBorder,
                  boxShadow: serverAppTheme?.popUp_box_shadow,
                  width: '75%',
                  margin: 'auto',
                  minHeight: '42%',
                  height: 'auto',
                  padding: '1.5rem',
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                }}
                noBackground
                customClass='h-100 w-100'
                customClass2='h-100 w-100 p-3'
              >
                <div style={{ flex: 1, color: serverAppTheme?.primary_text }} className="justify-content-center align-items-center text-center h-100 position-relative">
                  {/* <div className='col-12 fs_18 fw-700 text-center h-auto'>Are You Sure?</div><br /> */}
                  <div className="col-12 pt-4 px-0 fs_15 fw-400 text-center">
                    {CUSTOM_MESSAGES().LS_THIS_WILL_APPLY_THE_REWARD} <span className='fw-600'>{applyRewardConfirm?.reward?.name}</span>.{CUSTOM_MESSAGES().LS_DO_YOU_WANT_TO_CONTINUE}
                  </div>
                  <div style={{ bottom: '0', left: '0' }} className="col-12 px-0 h-30 d-flex justify-content-center align-items-center text-center position-absolute">
                    <div className='col-6 pl-0 pr-1'>
                      <TouchableButton
                        style={{ background: serverAppTheme?.OFF_Premise_Btn, color: serverAppTheme?.cancleBtn_font, border: serverAppTheme?.cancleBtn_Border }}
                        className={cn("col-12 fs_24 fw-600 btn-44 rounded btn44 od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color")}
                        type="button"
                        onClick={handleCancelApplyReward}
                        rippleEffect={true}
                      >
                        {LABEL().LS_NO}
                      </TouchableButton>
                    </div>
                    <div className='col-6 pl-1 pr-0'>
                      <TouchableButton
                        style={{ background: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color }}
                        className={cn("col-12 btn-ripple fs_24 fw-600 border-0 rounded btn44 od-primary-btn-bg-color od-primary-btn-font-color")}
                        type="button"
                        onClick={handleConfirmApplyReward}
                        rippleEffect={true}
                      >
                        {LABEL().LS_YES}
                      </TouchableButton>
                    </div>
                  </div>
                </div>
              </ModalPopup>
            )}
    </FullWidthModal>
  );
};

const mapStateToProps = ({ orders }) => ({
  orderingPortraitOrientation: orders.orderingPortraitOrientation,
});

export default connect(mapStateToProps)(SplitRewardsList);
